import { requestGetNameStudentById } from "services/general";

const useSearchStudent = ({
	loadingRequest,
	studentReservationExists,
	toastErrorSaveAttendance,
	studentToAdd,
	dialogResultSearchStudent,
}) => {
	const studentExistsInReservationList = () => {
		if (!studentReservationExists(studentToAdd.value.id)) return false;
		toastErrorSaveAttendance.show(
			"El alumno que intentas agregar ya se encuentra en la lista"
		);
		studentToAdd.clearStudentId();
		setTimeout(() => {
			toastErrorSaveAttendance.hide();
		}, 2400);
		return true;
	};
	const searchStudent = async () => {
		if (studentExistsInReservationList()) return;
		loadingRequest.show("Buscando alumno...");
		studentToAdd.clearStudentName();
		const studentName = await requestGetNameStudentById(
			studentToAdd.value.id
		);
		if (studentName) studentToAdd.fillForToast(studentName);
		loadingRequest.hide();
		dialogResultSearchStudent.set(true);
	};
	return searchStudent;
};

export default useSearchStudent;
